<template>
  <div class="login-wrapper">
    <h2>SIGN IN</h2>
    <el-form
      :model="form"
      :rules="rules"
      hide-required-asterisk
      label-position="top"
      ref="form"
      label-width="100px"
      class="login-form-wrapper"
      @keyup.enter.native="handleSubmit"
    >
      <el-form-item label="IT Code" prop="username">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item prop="password">
        <div class="password-wrapper" slot="label">
          <div class="label">Password</div>
          <div class="target">
            <span @click="$router.push('/user/forgot-password')">
              Forgot Password?
            </span>
          </div>
        </div>
        <el-input v-model="form.password" show-password />
      </el-form-item>
      <el-form-item label="Verification Code" prop="captcha">
        <div class="verification-wrapper">
          <el-input v-model="form.captcha" class="verification-input" />
          <img
            :src="imgCaptcha"
            alt="图片验证码"
            class="verification-captcha"
            @click="_getImgCaptcha"
          />
        </div>
      </el-form-item>
      <el-form-item>
        <customize-button
          :loading="loading"
          :type="loading ? 'disabled' : 'primary'"
          size="large"
          :btn-style="{ width: '240px' }"
          @click="handleSubmit"
        >
          Sign in
        </customize-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { login } from './api'
import { getImgCaptcha } from '@/api'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
        captcha: '',
      },
      rules: {
        username: [{ required: true, message: 'Can not be empty!' }],
        password: [{ required: true, message: 'Can not be empty!' }],
        captcha: [{ required: true, message: 'Can not be empty!' }],
      },
      imgCaptcha: '',
      loading: false,
    }
  },
  mounted() {
    this._getImgCaptcha()
  },
  methods: {
    ...mapMutations([
      'setMenus',
      'setUsername',
      'setToken',
      'setSource',
      'setItcode',
      'setBtnPermissionList',
    ]),
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this._login({ ...this.form })
        }
      })
    },
    async _login(params) {
      this.loading = true
      try {
        const { token, menus, name, source, btn } = await login({ ...params })
        this.setItcode(this.form.username)
        this.setMenus(menus)
        this.setUsername(name)
        this.setToken(token)
        this.setSource(source)
        this.setBtnPermissionList(btn)
        await this.$router.push('/dashboard')
      } catch (err) {
        console.error(err)
        await this._getImgCaptcha()
      }
      this.loading = false
    },
    _getImgCaptcha() {
      const date = Date.now()
      try {
        this.imgCaptcha = getImgCaptcha(date)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.login-wrapper {
  width: 650px;
  margin: 0 auto;

  h2 {
    font-size: 32px;
    color: #3a3f63;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 34px;
  }

  .login-form-wrapper {
    :deep(.el-form-item__label) {
      padding-bottom: 0;
      color: #000;
      font-size: 14px;
    }

    :deep(.el-input__inner) {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
    }

    .password-wrapper {
      width: 650px;
      display: flex;
      justify-content: space-between;

      .target {
        span {
          cursor: pointer;
          font-size: 14px;
        }
      }
    }

    .verification-wrapper {
      width: 650px;
      display: flex;
      justify-content: space-between;

      .verification-input {
        width: 420px;
      }

      .verification-captcha {
        width: 130px;
        height: 53px;
        cursor: pointer;
      }
    }
  }
}
</style>
